export default __webpack_public_path__ + "static/media/upload-id.384b7a1d.jpg";